import { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { enableSharing, disableSharing } from '../../hooks/useShare';
import styles from './ShareModal.module.css';

export default function ShareModal() {
  const { state, dispatch, user, activeHunt } = useAppContext();
  const shareToken = activeHunt ? state.shareTokens[activeHunt.id] : null;
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareUrl = shareToken
    ? `${window.location.origin}/share/${shareToken}`
    : null;

  function close() {
    dispatch({ type: 'CLOSE_MODAL' });
  }

  async function handleEnable() {
    if (!user || !activeHunt) return;
    setBusy(true);
    try {
      await enableSharing(user.uid, activeHunt.id, dispatch);
    } finally {
      setBusy(false);
    }
  }

  async function handleDisable() {
    if (!shareToken || !activeHunt) return;
    setBusy(true);
    try {
      await disableSharing(shareToken, activeHunt.id, dispatch);
    } finally {
      setBusy(false);
    }
  }

  async function handleCopy() {
    if (!shareUrl) return;
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className={styles.backdrop} onClick={(e) => e.target === e.currentTarget && close()}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <h2 className={styles.title}>Share “{activeHunt?.title}”</h2>
          <button className={styles.closeBtn} onClick={close} aria-label="Close">✕</button>
        </div>

        {!shareToken ? (
          <div className={styles.body}>
            <p className={styles.description}>
              Generate a private link that lets anyone view this hunt in read-only mode.
              You can revoke it at any time.
            </p>
            <div className={styles.actions}>
              <button className={styles.cancelBtn} onClick={close}>Cancel</button>
              <button className={styles.saveBtn} onClick={handleEnable} disabled={busy}>
                {busy ? 'Enabling…' : 'Enable sharing'}
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.body}>
            <p className={styles.description}>
              Anyone with this link can view this hunt.
            </p>
            <div className={styles.urlRow}>
              <span className={styles.url}>{shareUrl}</span>
              <button className={styles.copyBtn} onClick={handleCopy}>
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
            <div className={styles.actions}>
              <button className={styles.cancelBtn} onClick={handleDisable} disabled={busy}>
                {busy ? 'Stopping…' : 'Stop sharing'}
              </button>
              <button className={styles.saveBtn} onClick={close}>Done</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
